import fetcher from '@/lib/fetcher';
import { App } from '@prisma/client';
import useSWR, { mutate } from 'swr';
import type { ApiResponse } from 'types';

const useApp = (slug: string | undefined, appId: string | undefined) => {
  const url = `/api/teams/${slug}/apps/${appId}`;

  const { data, error, isLoading } = useSWR<ApiResponse<App>>(
    slug && appId ? url : null,
    fetcher
  );

  const mutateApp = async () => {
    mutate(url);
  };

  return {
    app: data?.data,
    isLoading,
    error,
    mutate: mutateApp,
  };
};

export default useApp;
